import { ensureFontAwesome } from "@ep/tools/fontawesome";
import { ensureMaterialIcons } from "@ep/tools/materialIcons";

class Icon {

  #getIconParameters(options) {
    const fontAwesome6 = ['solid', 'regular', 'light', 'brands', 'duo'];
    const fontAwesome5 = ['fas', 'far', 'fal', 'fab'];
    let classname, text = '';
    const fontAwesomeName = String(options.name || '').trim().replace(/^fa-/, '');

    if (options.class !== undefined && typeof options.class === 'string') {
      options.class = ' ' + options.class;
    } else {
      options.class = '';
    }

    if (options.type === 'ep') {
      classname = `${options.type} ${options.name} ${options.class}`;
    } else if (options.type === 'mi') {
      classname = `material-icons${options.class}`;
      text = options.name;
    } else if (fontAwesome5.indexOf(options.type) >= 0) {
      classname = `${options.type} fa-${fontAwesomeName} ${options.class}`;
    } else if (fontAwesome6.indexOf(options.type) >= 0) {
      classname = `fa-${options.type} fa-${fontAwesomeName} ${options.class}`;
    }

    return [classname, text, options.append, options.style];
  }

  setIcon(elem, options) {
    let [classes, text, append, style] = this.#getIconParameters(options.icon);
    const iconType = options?.icon?.type;
    const isFontAwesomeIcon = ['solid', 'regular', 'light', 'brands', 'duo', 'fas', 'far', 'fal', 'fab'].includes(iconType);

    if (iconType === 'mi') {
      void ensureMaterialIcons();
    }

    if (isFontAwesomeIcon) {
      void ensureFontAwesome(iconType);
    }

    if (typeof classes !== 'string' || classes.trim().length === 0) {
      return null;
    }

    const icon = document.createElement('i');
    if (icon.style) {
      const resolvedStyle = style && typeof style === 'object' ? { ...style } : {};
      if (typeof options?.icon?.color === 'string' && options.icon.color.trim()) {
        resolvedStyle.color = options.icon.color.trim();
      }
      Object.assign(icon.style, resolvedStyle);
    }

    if (append !== undefined && append === 'after') {
      elem.append(icon);
    } else {
      elem.prepend(icon);
    }

    classes.split(/\s/).map(classname => {
      if (classname !== undefined && typeof classname === 'string' && classname.length > 0) {
        icon.classList.add(classname);
      }

    });
    icon.innerText = text;
    return icon;
  }
}

const icon = new Icon();
export default (elem, options) => icon.setIcon(elem, options);
